import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// IMPORT YOUR TRANSLATIONS
import en from "./locales/en/translation.json";
import el from "./locales/el/translation.json";
import de from "./locales/de/translation.json";
import fr from "./locales/fr/translation.json";
import it from "./locales/it/translation.json";
import ru from "./locales/ru/translation.json";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      el: { translation: el },
      de: { translation: de },
      fr: { translation: fr },
      it: { translation: it },
      ru: { translation: ru }
    },

    lng: "en", // default language
    fallbackLng: "en",

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;